'use client';

import { forwardRef, useContext } from 'react';

import { cx } from '@/styled-system/css';

import { Text } from '../text/text';
import { TagRootContext } from './context/tag-root.context';
import { tagLabelRecipe } from './styles/tag-label.styles';
import type { TagLabelPropsInterface } from './types/tag-label.types';

/**
 * @since 10.0.0
 */
export const TagLabel = forwardRef<HTMLSpanElement, TagLabelPropsInterface>(
  (props, forwardedRef) => {
    const { size = 'md' } = useContext(TagRootContext);
    const { css: cssProp, ...rest } = props;

    return (
      <Text
        ref={forwardedRef}
        data-c11n-component="Tag.Label"
        data-c11n-version={__C11N_VERSION__}
        css={{
          ...tagLabelRecipe.raw({ size }),
          ...cssProp,
        }}
        {...rest}
        className={cx('c11n_tag__label', rest.className)}
      />
    );
  },
);

TagLabel.displayName = 'Tag.Label';
